module.exports = __webpack_public_path__ + "src/gpap-lib/img/icons/publish.svg";